// src/api/v3/product-images-api-v3.js
const API_BASE =
  process.env.REACT_APP_API_BASE

const ProductImagesAPI = {
  // replaceMany (legacy single/mapped upload)
  async replaceMany(productId, filesOrMap) {
    let formData
    if (filesOrMap instanceof FormData) {
      formData = filesOrMap
    } else {
      formData = new FormData()
      Object.entries(filesOrMap || {}).forEach(([kind, file]) => {
        if (!file) return
        formData.append(`files[${kind}]`, file)
      })
      formData.append('replace', 'true')
    }

    const url = `${API_BASE}/api/v3/products/${productId}/replace_images_bulk`
    const res = await fetch(url, {
      method: 'POST',
      body: formData,
      credentials: 'include',
    })
    const json = await res.json()
    if (!res.ok)
      throw new Error(json?.errors?.join(', ') || json?.error || 'Upload failed')
    return json
  },

  // Bulk multi-file uploader (drag-drop)
  async bulkUpload(productId, files) {
    const fd = new FormData()
    ;[].concat(files || []).forEach((f) => fd.append('files[]', f))
    const url = `${API_BASE}/api/v3/products/${productId}/product_images/bulk_create`
    const res = await fetch(url, { method: 'POST', body: fd, credentials: 'include' })
    const json = await res.json()
    if (!res.ok) throw new Error(json?.error || 'Bulk upload failed')
    return json // { items: [...] }
  },

  // Bulk update assignments (kind, position, cover)
  async updateMany(productId, images) {
    const url = `${API_BASE}/api/v3/products/${productId}/product_images/update_many`
    const res = await fetch(url, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ images }),
    })
    const json = await res.json()
    if (!res.ok)
      throw new Error(json?.error || 'Failed to update image mappings')
    return json
  },

  // Destroy by kind (legacy)
  async destroy(productId, kind) {
    const url = `${API_BASE}/api/v3/product_images`
    const res = await fetch(url, {
      method: 'DELETE',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ product_id: productId, kind }),
    })
    if (!res.ok) throw new Error('Failed to delete image')
    return true
  },

  // Destroy by id (for new UI)
  async destroyById(imageId) {
    const url = `${API_BASE}/api/v3/product_images/${imageId}`
    const res = await fetch(url, { method: 'DELETE', credentials: 'include' })
    if (!res.ok) throw new Error('Failed to delete image')
    return true
  },

  // S3 presign/finalize (for direct upload workflows)
  async presign(productId, kind, contentType) {
    const url = `${API_BASE}/api/v3/product_images/presign`
    const res = await fetch(url, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ product_id: productId, kind, content_type: contentType }),
    })
    const json = await res.json()
    if (!res.ok) throw new Error(json?.error || 'Presign failed')
    return json
  },

  async finalize(productId, kind, key, contentType, byteSize) {
    const url = `${API_BASE}/api/v3/product_images/finalize`
    const res = await fetch(url, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        product_id: productId,
        kind,
        key,
        content_type: contentType,
        byte_size: byteSize,
      }),
    })
    const json = await res.json()
    if (!res.ok) throw new Error(json?.error || 'Finalize failed')
    return json
  },
}

export default ProductImagesAPI
